import axios from "axios";

const API_URL = 'https://api.locationsapi.net/api/';

const SECRET_KEY = 'a1nm2o55l5';

const axiosConfig = {
    headers: {
        'X-SECRET-KEY': SECRET_KEY
    }
};

const getLocationByName = async (newLocation) => {
    try {
        const { data } = await axios.get(`${API_URL}location/search/${newLocation}`, axiosConfig);
        return data;
    } catch (error) {
        console.error('Error in getLocationByName:', error);
        throw new Error(error.response?.data?.message || 'Failed to get location by name');
    }
};

const getLocationById = async (id) => {
    try {
        const { data } = await axios.get(`${API_URL}${id}`, axiosConfig);
        return data;
    } catch (error) {
        console.error('Error in getLocationById:', error);
        throw new Error(error.response?.data?.message || 'Failed to get location by ID');
    }
};

const getCityList = async (countryId, stateId) => {
    try {
        const { data } = await axios.get(`${API_URL}city/country/${countryId}/state/${stateId}/active`, axiosConfig);
        return data;
    } catch (error) {
        console.error('Error in getCityList:', error);
        throw new Error(error.response?.data?.message || 'Failed to get city list');
    }
};

const getLocationByLocation = async (name) => {
    try {
        const { data } = await axios.get(`${API_URL}location/name/${name}`, axiosConfig);
        return data;
    } catch (error) {
        console.error('Error in getLocationByLocation:', error);
        throw new Error(error.response?.data?.message || 'Failed to get location by name');
    }
};

const LocationService = {
    getLocationByName,
    getLocationById,
    getCityList,
    getLocationByLocation
};

export default LocationService;
